import { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import AiGuidePage from "../ai-guide/ui/AiGuidePage";
import ChatQueryExamplesPage from "../chat-query-examples/ui/ChatQueryExamplesPage";

/** Guides, index mapping, and query examples that feed the AI. */
const AiContext = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const tab = params.get("tab");

  // Old hub links for tabs that moved under Data Pipeline.
  if (tab === "openapi") {
    return <Navigate to="/openapi-catalogs" replace />;
  }
  if (tab === "adaptor") {
    return <Navigate to="/adaptor-discovery" replace />;
  }
  if (tab === "schema") {
    return <Navigate to="/schema-relations" replace />;
  }

  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "documents",
        label: t("guide.tabDocuments"),
        icon: <DescriptionOutlinedIcon fontSize="small" />,
        render: () => <AiGuidePage section="documents" />,
      },
      {
        key: "mapping",
        label: t("guide.tabMapping"),
        icon: <AccountTreeOutlinedIcon fontSize="small" />,
        render: () => <AiGuidePage section="mapping" />,
      },
      {
        key: "examples",
        label: t("nav.chatQueryExamples"),
        icon: <QuestionAnswerOutlinedIcon fontSize="small" />,
        render: () => <ChatQueryExamplesPage />,
      },
    ],
    [t]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("nav.aiContext")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default AiContext;
